import type { DivisionId } from '../types/division.js';

/** Accepte 1–4 (number ou string numérique) ; sinon `null`. */
export function parseSeasonJoinDivisionId(raw: unknown): DivisionId | null {
  const n = typeof raw === 'number' ? raw : typeof raw === 'string' ? Number(raw.trim()) : NaN;
  if (n === 1 || n === 2 || n === 3 || n === 4) return n;
  return null;
}

export type SeasonJoinCardAction = 'hidden' | 'join' | 'registered';

/**
 * Action d'inscription affichée sur une carte division pendant la fenêtre
 * `registration` : un joueur avec pilote peut rejoindre n'importe quelle division.
 */
export function seasonJoinCardAction(
  cardDivisionId: DivisionId,
  opts: { hasDriver: boolean; registeredDivision: DivisionId | null }
): SeasonJoinCardAction {
  if (!opts.hasDriver) return 'hidden';
  if (opts.registeredDivision === cardDivisionId) return 'registered';
  return 'join';
}
